<template>
  <div style="display: contents;">
  <v-dialog v-model="dialogOpen"
    v-if="dialogOpen"
    persistent
    max-width="630"
    content-class="account-details-dialog"
    @keydown.esc="close">
    <v-card class="glass-card-account-details">
      <v-form ref="accountForm"
        @submit.prevent="finish">
        <v-card-title class="glass-header-account-details pa-0">
          <v-row class="ma-0 pa-4 align-center">
            <v-col cols="auto" class="pa-0">
              <v-icon color="white" size="28">mdi-account-card-details</v-icon>
            </v-col>
            <v-col class="pa-0 pl-3">
              <h3 class="white--text" style="font-weight: 600; font-size: 18px; letter-spacing: 0.3px;">
                {{ $t("$vuetify.accountDetailsTitle") }}
              </h3>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="pa-0 d-flex align-center">
              <span style="color: white; font-size: 13px; font-weight: 500; letter-spacing: 0.3px;">
                {{ $t("$vuetify.formDetails.saveAssociate") }}
              </span>
              <v-checkbox
                class="ml-2 mt-0 pt-0"
                v-model="doSaveAccount"
                dark
                hide-details
                dense
              ></v-checkbox>
            </v-col>
            <v-col cols="auto" class="pa-0 pl-3">
              <v-icon large color="white" @click="close">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="pt-4 px-4 pb-2">
          <v-container class="pa-0">
            <v-row class="input-row mb-3">
              <v-col cols="12" class="py-0">
                <div class="field-label">{{ $t('$vuetify.formDetails.oib') }}</div>
                <v-combobox
                  clearable
                  @focus="showKbd"
                  data-layout="number"
                  :placeholder="$t('$vuetify.filterPlaceholderLabel')"
                  v-model="payerOib"
                  :search-input.sync="oibSearchInput"
                  :items="oibOptions"
                  :loading="loadingOib"
                  validate-on-blur
                  @update:search-input="onOibSearch"
                  @input="onOibInput"
                  @change="onOibChange"
                  @click:clear="clearForm"
                  class="account-input uppercased-input"
                  outlined
                  dense
                  hide-details="auto"
                  item-text="oib"
                  item-value="oib"
                  return-object
                  maxlength="11"
                >
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item
                      v-on="on"
                      v-bind="attrs"
                      @click="selectAssociateByOib(item)">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.oib }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>

            <v-row class="input-row mb-3">
              <v-col cols="12" class="py-0">
                <div class="field-label">{{ $t('$vuetify.formDetails.name') }}</div>
                <v-combobox
                  @focus="showKbd"
                  data-layout="normalAduro"
                  :placeholder="$t('$vuetify.filterPlaceholderLabel')"
                  v-model="payer"
                  :loading="loading"
                  :items="associates"
                  return-object
                  item-text="name"
                  item-value="name"
                  @change="onNameChange"
                  :search-input.sync="payerName"
                  @update:search-input="querySelections"
                  hide-no-data
                  clearable
                  @click:clear="clearForm"
                  :rules="[rules.req]"
                  class="account-input uppercased-input"
                  outlined
                  dense
                  hide-details="auto"
                >
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item class="uppercased-input"
                      v-on="on"
                      v-bind="attrs">{{ item.name }}</v-list-item>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>

            <v-row class="input-row mb-3">
              <v-col cols="12" class="py-0">
                <div class="field-label">{{ $t('$vuetify.formDetails.address') }}</div>
                <v-text-field
                  @focus="showKbd"
                  data-layout="normalAduro"
                  class="account-input uppercased-input"
                  v-model="payerAddress"
                  :rules="[rules.req]"
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="input-row mb-3">
              <v-col cols="12" class="py-0">
                <div class="field-label">{{ $t('$vuetify.formDetails.city') }}</div>
                <v-text-field
                  @focus="showKbd"
                  data-layout="normalAduro"
                  v-model="payerCity"
                  :rules="[rules.req]"
                  class="account-input uppercased-input"
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="input-row mb-3">
              <v-col cols="12" class="py-0">
                <div class="field-label">{{ $t('$vuetify.formDetails.zipCode') }}</div>
                <v-text-field
                  @focus="showKbd"
                  data-layout="normalAduro"
                  v-model="payerZip"
                  :rules="[rules.req]"
                  class="account-input uppercased-input"
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="input-row mb-3">
              <v-col cols="12" class="py-0">
                <div class="field-label">{{ $t('$vuetify.formDetails.country') }}</div>
                <v-select
                  @focus="showKbd"
                  data-layout="normalAduro"
                  :items="countries"
                  v-model="payerCountry"
                  item-text="country"
                  item-value="country"
                  :rules="[rules.req]"
                  class="account-input uppercased-input"
                  outlined
                  dense
                  hide-details="auto"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="d-flex justify-end px-4 pb-4">
          <v-btn
            outlined
            color="primary"
            @click="close"
            class="cancel-btn-account-details mr-2"
            elevation="0"
          >
            Odustani
          </v-btn>
          <v-btn
            type="submit"
            class="submit-btn-account-details"
            elevation="0"
            id="finishPayment"
          >
            {{ $t("$vuetify.finishPayment") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <v-overlay v-if="loading" absolute z-index="10">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>

    <v-container class="kbd"
      v-if="!$vuetify.breakpoint.smAndDown"
      ref="keyboard"
      v-show="oskVisible"
      :style="{ 'max-width': width }">
      <div class="kbd-header"></div>
      <vue-touch-keyboard :options="oskOptions"
        :layout="layout"
        :cancel="hideKbd"
        :accept="accept"
        :input="input" />
    </v-container>
  </v-dialog>
  </div>
</template>

<script>
import state from '@/state'
import rules from '@/plugins/rules'
import countries from '@/mixins/countries'
import { clone, toISOLocal } from '@/plugins/utils'
import { df, auth, functions } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import { printerInit } from '@/libs/bixolon/printer'
import onScreenKeyboard from '@/mixins/onScreenKeyboard'
import { callAssociates, callBusinessEntities } from '@/api/associates'

export default {
  mixins: [countries, onScreenKeyboard],

  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'openPdfPrint'],

  data () {
    return {
      templatesDialogOpen: false,
      dialogOpen: false,
      loading: false,
      loadingOib: false,
      listeners: [],
      defaultAssociates: [],
      associates: [],
      oibSearchInput: '',
      oibOptions: [],
      fiscalize: false,
      payerName: undefined,
      payer: undefined,
      payerAddress: undefined,
      payerCity: undefined,
      payerZip: undefined,
      payerCountry: undefined,
      payerOib: undefined,
      rules: {
        req: rules.req(),
        oib: rules.oib()
      },
      inEu: false,
      languages: [],
      language: {},
      note: undefined,
      receiptNumber: 1,
      offer_sequence: undefined,
      bill_sequence: undefined,
      last_receipt: undefined,
      minIssueDate: undefined,
      flag: undefined,
      doSaveAccount: false,
      saveAssociateEnabled: true,
      submitting: false,
      takenOibs: [],
      receipt: {},
      oibSearchTimer: null,
      nameSearchTimer: null,
      isSelectingOib: false,
      isSelectingName: false,
      lastOibSearchHadResults: false,
      lastOibQuery: ''
    }
  },

  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },

  watch: {
    storeReceiptNumber (nv) {
      this.receiptNumber = nv + 1
    },
    payerOib (nv) {
      if (nv && nv.length === 11) {
        if (this.takenOibs.includes(nv)) {
          this.doSaveAccount = false
          this.saveAssociateEnabled = false
        } else {
          this.saveAssociateEnabled = true
        }
      }
    }
  },

  computed: {
    storeReceiptNumber () {
      if (this.receiptType && this.receiptType.value === 'P') {
        return this.offer_sequence
      } else {
        return this.bill_sequence
      }
    }
  },

  methods: {
    open (receipt) {
      this.receipt = { ...receipt }

      this.payerAddress = this.receipt.type.payer_address
      this.payerCity = this.receipt.type.payer_city
      this.payerCountry = this.receipt.type.payer_country || 'Hrvatska'
      this.payer = this.receipt.type.payer_name
      this.payerOib = this.receipt.type.payer_oib
      this.payerZip = this.receipt.type.payer_zip_code

      // Associates are loaded on-demand when user starts typing (3+ chars)
      this.associates = []
      this.defaultAssociates = []

      this.dialogOpen = true
    },
    close () {
      if (this.$refs.accountForm) {
        this.$refs.accountForm.reset()
      }
      this.dialogOpen = false
    },
    async finish () {
      if (!this.$refs.accountForm.validate()) {
        return
      }

      // Spremi klijenta ako je checkbox označen
      if (this.doSaveAccount) {
        // Ekstraktuj samo stringove (mogu biti objekti ili stringovi)
        const nameValue = typeof this.payer === 'object' ? this.payer.name : (this.payerName || this.payer)
        const oibValue = typeof this.payerOib === 'object' ? this.payerOib.oib : this.payerOib

        var associateForSave = {
          name: nameValue,
          oib: oibValue,
          address: this.payerAddress,
          city: this.payerCity,
          zip_code: this.payerZip,
          country: this.payerCountry
        }
        await this.saveAssociate(associateForSave)
      }

      this.changeReceiptType()
      this.$refs.accountForm.reset()
    },

    // Provjeri da li je račun fiskaliziran
    isFiscalized () {
      return this.receipt.fiscalize === true && this.receipt.zki !== ''
    },

    // Provjeri da li je račun transakcijski
    isTransactional () {
      return this.receipt.payment_method === 'TRANSAKCIJSKI RAČUN'
    },

    // Provjeri da li je OIB promijenjen
    isOibChanged (newOib) {
      const oldOib = this.receipt.type.payer_oib || ''
      return oldOib !== newOib
    },

    // Pozovi receiptapi za promjenu OIB-a
    async callReceiptApiForOibChange (newOib) {
      const me = this
      const receiptApi = functions.httpsCallable('receiptapi')

      const params = {
        company_id: state.getCurrentCompany().id,
        payer_oib: newOib
      }

      return receiptApi({
        action: {
          operation: 'update',
          entity: 'payment',
          resource_id: this.receipt.id,
          params: params
        }
      })
        .then((doc) => {
          // Provjera greške - identična logika kao PaymentChange.vue
          const isError = (doc.header && doc.header.code !== 200) ||
                         (doc.data && doc.data.status !== 'OK' && doc.data.code !== 200)

          if (isError) {
            const errorMessage = (doc.data && doc.data.error) ||
                                (doc.header && doc.header.error) ||
                                'Promjena OIB-a nije uspjela.'
            me.showMsgBox({
              title: 'Greška pri promjeni OIB-a',
              text: errorMessage,
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
            throw new Error(errorMessage) // Throw error da se zaustavi dalje izvršavanje
          }

          // Uspješan receiptapi poziv
          return doc
        })
        .catch((error) => {
          console.error('receiptapi error:', error)
          throw error // Re-throw da parent handler može uhvatiti
        })
    },

    async changeReceiptType () {
      const me = this

      // Pripremi type objekt (kao i do sada)
      var type = {
        payer_address: this.payerAddress,
        payer_city: this.payerCity,
        payer_country: this.payerCountry,
        payer_name: typeof this.payer === 'object' ? this.payer.name : this.payer,
        payer_oib: this.payerOib,
        payer_zip_code: this.payerZip,
        flag: 'R'
      }

      // NOVA LOGIKA: Provjeri da li treba pozvati receiptapi
      const needsReceiptApi = this.isFiscalized() &&
                             !this.isTransactional() &&
                             this.isOibChanged(this.payerOib)

      try {
        // AKO treba receiptapi, prvo pozovi ga
        if (needsReceiptApi) {
          me.loading = true // Prikaži loading
          await this.callReceiptApiForOibChange(this.payerOib)
          // Ako dođe do greške, callReceiptApiForOibChange će throwati error
        }

        // receiptapi je prošao OK (ili nije bio potreban)
        // Sada uradi Firestore update (kao i do sada)
        df.doc(`receipts/${state.getCurrentCompany().id}/receipts/${this.receipt.id}`).update({
          type: type
        })
          .then(() => {
            console.info('Receipt succesfully updated')
            me.$emit('refresh', type)
            me.$emit('success', 'Podaci uspješno promijenjeni')
            me.loading = false
            me.close()
          })
          .catch((error) => {
            console.error('Firestore update error:', error)
            me.loading = false
            me.showMsgBox({
              text: 'Pogreška prilikom zapisa podataka',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })
      } catch (error) {
        // receiptapi je failao - ne nastavljamo sa Firestore update-om
        console.error('receiptapi failed, aborting Firestore update:', error)
        me.loading = false
        // showMsgBox je već prikazan u callReceiptApiForOibChange
      }
    },

    setDefaults () {
      this.fiscalize = true
      this.languages = [
        { name: this.$t('$vuetify.receiptLanguages.hr'), value: 'hr' },
        { name: this.$t('$vuetify.receiptLanguages.en'), value: 'en' }
      ]
      this.language = this.languages[0]
      this.note = ''
      this.flag = 'R'
    },

    setForm (data = true) {
      if (data) {
        this.referenceNumber = ''
        if (this.payer && typeof this.payer === 'object') {
          // Set flag to prevent OIB search when name is selected
          this.isSelectingOib = true

          // this.payerCountry = this.payer.country
          this.payerCountry = 'Hrvatska'
          this.payerOib = this.payer.oibs ? this.payer.oibs[0] : ''
          this.payerAddress = this.payer.address
          this.payerCity = this.payer.city
          this.payerZip = this.payer.zip_code

          this.saveAssociateEnabled = false
          this.associates = [] // Clear dropdown after selection
        }
      } else {
        this.referenceNumber = ''
        this.associates = clone(this.defaultAssociates)
        this.saveAssociateEnabled = true
        this.$nextTick(() => {
          // this.$refs.accountForm.reset()
        })
      }
    },

    clearForm () {
      // Clear all form fields
      this.payer = undefined
      this.payerName = undefined
      this.payerOib = undefined
      this.payerAddress = undefined
      this.payerCity = undefined
      this.payerZip = undefined
      this.payerCountry = 'Hrvatska'
      this.associates = []
      this.oibOptions = []
      this.oibSearchInput = ''
      this.saveAssociateEnabled = true
      // Reset search state
      this.lastOibSearchHadResults = false
      this.lastOibQuery = ''
      this.loadingOib = false
      this.isSelectingOib = false
      this.isSelectingName = false
    },

    getMultiplier () {
      const listener = df.doc('project_constants/config').onSnapshot(doc => {
        this.config = doc.data()
        this.paymentModels = doc.data().payment_models
        this.multiplier = doc.data().item_amount.decimal_multiplier
      })
      this.listeners.push(listener)
    },

    getEuCountries () {
      const listener = df.doc('project_constants/countries').onSnapshot(doc => {
        this.euCountries = doc.data().eu_countries
      })
      this.listeners.push(listener)
    },

    async querySelections () {
      // Skip search if user is selecting from dropdown
      if (this.isSelectingName) {
        this.isSelectingName = false
        return
      }

      // Debounce search - wait 300ms after user stops typing
      clearTimeout(this.nameSearchTimer)

      if (!this.payerName || this.payerName.length < 3) {
        this.associates = []
        return
      }

      this.nameSearchTimer = setTimeout(async () => {
        this.loading = true
        await this.searchAssociatesByName(this.payerName)
        this.loading = false
      }, 300)
    },

    // Validacija OIB unosa - samo brojevi, max 11
    onOibInput (value) {
      if (typeof value === 'string') {
        // Ukloni sve što nije broj
        const numbersOnly = value.replace(/[^\d]/g, '')
        // Ograniči na 11 znamenaka
        const limited = numbersOnly.slice(0, 11)

        if (limited !== value) {
          this.$nextTick(() => {
            this.payerOib = limited
            this.oibSearchInput = limited
          })
        }
      }
    },

    onOibSearch (searchValue) {
      // Skip search if user is selecting from dropdown
      if (this.isSelectingOib) {
        this.isSelectingOib = false
        return
      }

      // Debounce search - wait 300ms after user stops typing
      clearTimeout(this.oibSearchTimer)

      if (!searchValue || searchValue.length < 3) {
        this.oibOptions = []
        this.lastOibSearchHadResults = false
        this.lastOibQuery = ''
        return
      }

      // Ako je tačno 11 znamenaka, uvijek traži (businessentities check)
      if (searchValue.length === 11) {
        this.oibSearchTimer = setTimeout(async () => {
          await this.searchAssociatesByOib(searchValue)
        }, 300)
        return
      }

      // Ako je prošla pretraga bila neuspješna i novi query počinje sa istim karakterima, ne traži
      if (!this.lastOibSearchHadResults &&
          this.lastOibQuery &&
          searchValue.startsWith(this.lastOibQuery)) {
        return
      }

      this.oibSearchTimer = setTimeout(async () => {
        await this.searchAssociatesByOib(searchValue)
      }, 300)
    },

    async searchAssociatesByOib (oibQuery) {
      // Search associates by OIB with trigram filter
      if (!oibQuery || oibQuery.length < 3) {
        this.oibOptions = []
        this.lastOibSearchHadResults = false
        this.lastOibQuery = ''
        return
      }

      try {
        this.loadingOib = true

        // Resetuj oibOptions prije pretrage
        this.oibOptions = []

        // Trigram pretraga u associates
        const path = `/associates/${state.getCurrentCompany().id}/associate?filter=trigram(eq:${encodeURIComponent(oibQuery)})`
        const response = await callAssociates('get', path)

        if (response && response.status === 200 && response.data && response.data.associates) {
          const associatesList = Object.keys(response.data.associates)
            .map((key) => response.data.associates[key])
            .filter((associate) => associate.status === 'OK')

          // For OIB search, flatten all OIBs and create options
          const oibOptionsArray = []
          associatesList.forEach(associate => {
            if (associate.oibs && associate.oibs.length > 0) {
              associate.oibs.forEach(oib => {
                if (oib.toLowerCase().includes(oibQuery.toLowerCase())) {
                  oibOptionsArray.push({
                    oib: oib,
                    name: associate.name,
                    address: associate.address,
                    city: associate.city,
                    zip_code: associate.zip_code,
                    country: associate.country,
                    fullAssociate: associate
                  })
                }
              })
            }
          })

          this.oibOptions = oibOptionsArray

          // Zapamti da li je pretraga imala rezultate
          this.lastOibSearchHadResults = oibOptionsArray.length > 0
          this.lastOibQuery = oibQuery
        } else {
          this.lastOibSearchHadResults = false
          this.lastOibQuery = oibQuery
        }

        // Ako je TAČNO 11 znamenaka i nema rezultata iz associates, pokušaj businessentities
        if (oibQuery.length === 11 && this.oibOptions.length === 0) {
          await this.checkBusinessEntities(oibQuery)
          // Ako businessentities nađe nešto, ažuriraj flag
          if (this.oibOptions.length > 0) {
            this.lastOibSearchHadResults = true
          }
        }
      } catch (error) {
        console.error('Error searching associates by OIB:', error)
        this.oibOptions = []
        this.lastOibSearchHadResults = false
        this.lastOibQuery = oibQuery
      } finally {
        this.loadingOib = false
      }
    },

    async checkBusinessEntities (oib) {
      if (!oib || oib.length !== 11) {
        return
      }

      try {
        const response = await callBusinessEntities(oib)

        // Struktura je response.data.data.business_entity (axios dodaje jedan nivo)
        if (response && response.status === 200 && response.data && response.data.data && response.data.data.business_entity) {
          const entity = response.data.data.business_entity

          // Mapiranje iz businessentities strukture
          const name = entity.name || ''
          const address = entity.headquatersAddress || ''
          const city = entity.headquatersCity || ''
          const zip_code = entity.headquatersZip || ''

          // Dodaj u oibOptions ako već nije tu
          const exists = this.oibOptions.some(opt => opt.oib === oib)

          if (!exists) {
            this.oibOptions.unshift({
              oib: oib,
              name: name,
              address: address,
              city: city,
              zip_code: zip_code,
              country: 'Hrvatska',
              fullAssociate: {
                name: name,
                oibs: [oib],
                address: address,
                city: city,
                zip_code: zip_code,
                country: 'Hrvatska'
              }
            })
          }
        }
      } catch (error) {
        // OIB not found in business entities registry
      }
    },

    onOibChange (selectedValue) {
      // When user selects from dropdown (by click or enter)
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.fullAssociate) {
        this.isSelectingOib = true // Flag to prevent search on next update
        this.selectAssociateByOib(selectedValue)
        this.oibOptions = [] // Clear dropdown options after selection
      }
    },

    onNameChange (selectedValue) {
      // When user selects name from dropdown
      if (selectedValue && typeof selectedValue === 'object') {
        this.isSelectingName = true // Flag to prevent search on next update
        this.setForm(true)
        this.associates = [] // Clear dropdown after selection
      }
    },

    selectAssociateByOib (selectedItem) {
      // When user selects an OIB from dropdown, populate all fields
      if (selectedItem && selectedItem.fullAssociate) {
        const associate = selectedItem.fullAssociate

        // Set flag to prevent name search when OIB is selected
        this.isSelectingName = true

        this.payer = associate
        this.payerOib = selectedItem.oib
        this.payerAddress = associate.address || ''
        this.payerCity = associate.city || ''
        this.payerZip = associate.zip_code || ''
        this.payerCountry = associate.country || 'Hrvatska'
        this.saveAssociateEnabled = false
      }
    },

    async searchAssociatesByName (nameQuery) {
      // Search associates by name with trigram filter
      if (!nameQuery || nameQuery.length < 3) {
        this.associates = []
        return
      }

      try {
        const path = `/associates/${state.getCurrentCompany().id}/associate?filter=trigram(eq:${encodeURIComponent(nameQuery)})`
        const response = await callAssociates('get', path)

        if (response && response.status === 200 && response.data && response.data.associates) {
          this.associates = Object.keys(response.data.associates)
            .map((key) => response.data.associates[key])
            .filter((associate) => associate.status === 'OK')
            .sort((a, b) => a.name.localeCompare(b.name))
        } else {
          this.associates = []
        }
      } catch (error) {
        console.error('Error searching associates by name:', error)
        this.associates = []
      }
    },

    backwardStep () {
      this.setForm(false)
      this.$emit('closeR1Dialog')
    },

    dateTimeToUnixTimestamp (dt) {
      return Math.floor(new Date(toISOLocal(dt)).getTime() / 1000)
    },

    showSnackbar (text, color = 'info') {
      // Emit event prema parent komponenti (ChangeReceiptTypeDialog) koja ima snackbar
      this.$emit('show-snackbar', { text, color })
    },

    async saveAssociate (associate) {
      const payload = {
        company_id: state.getCurrentCompany().id,
        name: associate.name,
        oibs: [associate.oib],
        address: associate.address,
        city: associate.city,
        zip_code: associate.zip_code,
        country: associate.country,
        associate_type: { BUYER: true },
        cost_centers: {}
      }

      var path = `/associates/${state.getCurrentCompany().id}/associate`
      var response = await callAssociates('post', path, payload)

      // Provjeri da li je HTTP status 200 I da li je response.data.status === 'Error'
      if (response.status === 200 && response.data && response.data.status !== 'Error') {
        this.showSnackbar(`Klijent "${associate.name}" uspješno spremljen`, 'success')
      } else {
        // Dohvati error poruku iz različitih mogućih lokacija
        const errorMessage = response?.data?.message || response?.data?.error || ''

        // Provjeri da li se radi o dupliciranom klijentu
        if (errorMessage.includes('već postoji') || errorMessage.includes('already exists')) {
          this.showSnackbar('Klijent već postoji, neće biti ponovno spremljen', 'warning')
        } else {
          this.showSnackbar(errorMessage || 'Neuspjelo dodavanje novog klijenta', 'error')
        }
      }
    },

    detachListeners () {
      this.listeners.forEach((listener) => {
        listener()
        this.listeners = this.listeners.filter((l) => l !== listener)
      })
    }
  },

  mounted () {
    // document.getElementById('oibInput').click()
    if (state.getPrinter() === 'BIXOLON80') {
      const issueID = 1
      printerInit(issueID)
      state.setPosPrinterSettings(2)
    }

    this.setDefaults()
    this.getMultiplier()
    this.getEuCountries()

    this.payerCountry = 'Hrvatska'

    // Associates are now loaded in open() method, not on mount
    // this.getAssociates()

    this.minIssueDate = toISOLocal(new Date())
    this.listeners.push(
      df
        .doc(`cash_registers/${state.getCashRegister().id}`)
        .onSnapshot((doc) => {
          if (doc && doc.data()) {
            this.offer_sequence = doc.data().offer_sequence
            this.bill_sequence = doc.data().bill_sequence
            this.last_receipt = doc.data().last_receipt_issued_timestamp
            if (this.last_receipt) {
              this.minIssueDate = toISOLocal(
                new Date(this.last_receipt * 1000)
              )
            } else {
              this.minIssueDate = toISOLocal(new Date())
            }
          }
        })
    )
  },
  beforeDestroy () {
    this.detachListeners()
  }
}
</script>

<style scoped>
/* Glass Card with Brand Gradient Header */
.glass-card-account-details {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.15) !important;
  overflow: hidden;
  max-height: 90vh;
  overflow-y: auto;
}

.glass-header-account-details {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%) !important;
  position: sticky;
  top: 0;
  z-index: 1;
}

/* Field Labels */
.field-label {
  font-size: 12px;
  color: rgba(57, 137, 201, 0.8);
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 6px;
}

/* Input Fields */
.account-input {
  border-radius: 10px !important;
}

.account-input >>> .v-input__control {
  border-radius: 10px !important;
}

.account-input >>> fieldset {
  border-color: rgba(57, 137, 201, 0.25) !important;
  border-width: 1.5px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.account-input >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
}

.account-input:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.account-input.v-input--is-focused >>> fieldset {
  border-color: rgba(57, 137, 201, 0.7) !important;
  border-width: 2px !important;
  box-shadow: 0 0 0 3px rgba(57, 137, 201, 0.1) !important;
}

.account-input.error--text >>> fieldset {
  border-color: rgba(244, 67, 54, 0.7) !important;
  background: rgba(244, 67, 54, 0.05) !important;
}

/* Input Row Spacing */
.input-row {
  margin-bottom: 12px;
}

/* Buttons */
.cancel-btn-account-details {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.12) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.cancel-btn-account-details:hover {
  background: rgba(57, 137, 201, 0.1) !important;
  border-color: rgba(57, 137, 201, 0.4) !important;
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.2) !important;
  transform: translateY(-2px);
}

.submit-btn-account-details {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.95) 0%,
    rgba(57, 137, 201, 0.9) 50%,
    rgba(97, 84, 164, 0.95) 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 16px rgba(57, 137, 201, 0.3) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 10px 32px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.submit-btn-account-details:hover {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 1) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  box-shadow: 0 6px 20px rgba(57, 137, 201, 0.4) !important;
  transform: translateY(-2px);
}

/* Uppercase Input Text */
.uppercased-input >>> input {
  text-transform: uppercase !important;
}

.uppercased-input >>> .v-select__selection {
  text-transform: uppercase !important;
}
</style>
